import { t } from 'i18next'

/**
 * Form constants
 */
const DATE = 'date'
const GROUP = 'group'
const GROUP_COURSE_SESSION = 'group_course_session'

/**
 * Form model
 */
const formModel = () => {
  return {
    [DATE]: {
        label: `${t('common.lesson-date')}`,
        name: DATE,
    },
    [GROUP]: {
      label: `${t('common.group')}`,
      name: GROUP,
    },
    [GROUP_COURSE_SESSION]: {
      label: `${t('common.classroom-lesson')}`,
      name: GROUP_COURSE_SESSION,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [DATE]: null,
  [GROUP]: null,
  [GROUP_COURSE_SESSION]: null,
}

export default formModel
